import utils from './utilities';
import listingUtils from './listingUtilities';
import reportUtils from './reportUtilities';

export const ZAMEEN_KEY = 'zameen';

const zameenUtilities = Object.freeze({ key: ZAMEEN_KEY, ...utils, ...reportUtils, ...listingUtils });

export default zameenUtilities;
